import { createAction, props } from '@ngrx/store';

import { OrderAnalysicModel } from '@app/models/myoffice/order/order-analysic.model';

// order analysic by rank
export const orderAnalysicByRank = createAction(
  "[Order API] search order analysis by rank",
  props<{ year:string , userid: string,typesearch:string  }>()
);

export const orderAnalysicByRankSuccess = createAction(
  "[Order API] search order analysis by rank success",
  props<{ items: OrderAnalysicModel[] }>()
);

export const orderAnalysicByRankFailure = createAction(
  "[Order API] search order analysis by rank failure",
  props<{ msg: any }>()
);


// order analysic by age
export const orderAnalysicByAge = createAction(
  "[Order API] search order analysis by age",
  props<{ year:string , userid: string,typesearch:string  }>()
);

export const orderAnalysicByAgeSuccess = createAction(
  "[Order API] search order analysis by age success",
  props<{ items: OrderAnalysicModel[] }>()
);

export const orderAnalysicByAgeFailure = createAction(
  "[Order API] search order analysis by age failure",
  props<{ msg: any }>()
);


// order analysic by month
export const orderAnalysicByMonth = createAction(
  "[Order API] search order analysis by month",
  props<{ year:string , userid: string,typesearch:string  }>()
);

export const orderAnalysicByMonthSuccess = createAction(
  "[Order API] search order analysis by month success",
  props<{ item: OrderAnalysicModel}>()
);

export const orderAnalysicByMonthFailure = createAction(
  "[Order API] search order analysis by month failure",
  props<{ msg: any }>()
);


// order analysic by cate
export const orderAnalysicByCate = createAction(
  "[Order API] search order analysis by cate",
  props<{ year:string , userid: string,typesearch:string  }>()
);

export const orderAnalysicByCateSuccess = createAction(
  "[Order API] search order analysis by cate success",
  props<{ items: OrderAnalysicModel[] }>()
);

export const orderAnalysicByCateFailure = createAction(
  "[Order API] search order analysis by cate failure",
  props<{ msg: any }>()
);

// order analysic by product
export const orderAnalysicByProduct = createAction(
  "[Order API] search order analysis by product",
  props<{ year:string , userid: string,typesearch:string  }>()
);

export const orderAnalysicByProductSuccess = createAction(
  "[Order API] search order analysis by product success",
  props<{ items: OrderAnalysicModel[] }>()
);

export const orderAnalysicByProductFailure = createAction(
  "[Order API] search order analysis by product failure",
  props<{ msg: any }>()
);


